import { CommunicationSidebarCreate } from './communication-sidebar-create';
import { CommunicationSidebarFilters } from './communication-sidebar-filters';
import { CommunicationSidebarRefresh } from './communication-sidebar-refresh';

export function CommunicationSidebarHeader() {
  return (
    <div className="flex items-center justify-between border-b p-4">
      <h2 className="text-lg font-semibold text-gray-900">Communication</h2>
      <div className="flex items-center space-x-2">
        <CommunicationSidebarFilters />
        <CommunicationSidebarCreate />
        <CommunicationSidebarRefresh />
      </div>
    </div>
  );
}
